//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as orderTagApi from '@/api/orderTagApi.js';
import { Debounce } from '@/utils/validate';
import * as dangaoActApi from '@/api/dangaoActApi';
import * as storeApi from '@/api/store';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      details: {},
      // 预留一份数据
      productId: '',
      tagOption: [],
      pram: {},
      initloading: false
    };
  },
  props: {
    bindType: {
      // 打标类型 0: 订单列表打标 1: 三方订单打标
      type: [Number, String],
      default: 0
    }
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(productId) {
      this.productId = productId;
      this.pram = {};
      this.visible = true;
      this.getAllTags();
    },
    handerSubmit: Debounce(function () {
      var _this$pram,
        _this$pram$labelIds,
        _this = this;
      this.loading = true;
      dangaoActApi.saveCakeTag({
        productId: this.productId,
        labelIds: (_this$pram = this.pram) === null || _this$pram === void 0 ? void 0 : (_this$pram$labelIds = _this$pram.labelIds) === null || _this$pram$labelIds === void 0 ? void 0 : _this$pram$labelIds.join(',')
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getAllTags: function getAllTags() {
      var _this2 = this;
      this.visible = true;
      this.initloading = true;
      this.tagOption = [];
      storeApi.getLabelApi({
        type: 3
      }).then(function (res) {
        _this2.tagOption = res || [];
        _this2.initloading = false;
      }).catch(function (err) {
        _this2.initloading = false;
      });
    }
  }
};